import { GET_PLANS, GET_ACCOUNT_DETAIL, GET_API_KEYS, CREATE_API_KEY, REVOKE_API_KEY, DELETE_API_KEY, GET_COMPANIES, CREATE_COMPANY, UPDATE_COMPANY_STATUS, UPDATE_COMPANY, GET_CLIENT_COMPANIES, CREATE_CLIENT_COMPANY, UPDATE_CLIENT_COMPANY_STATUS, UPDATE_CLIENT_COMPANY, GET_COMPANY_MEMBERS, ADD_COMPANY_MEMBER, UPDATE_MEMBER_PERMISSIONS, UPDATE_MEMBER_STATUS, GET_MEMBER_BY_ID, GET_COMPANY_ROLES, GET_MODULES, GET_APP_PERMISSIONS, CREATE_COMPANY_ROLE, UPDATE_COMPANY_ROLE, DELETE_COMPANY_ROLE, GET_HIRING_STATUSES, CREATE_HIRING_STATUS, UPDATE_HIRING_STATUS, DELETE_HIRING_STATUS, REORDER_HIRING_STATUSES } from "../Types/types";

let intialState = {
    plans: [],
    isTestLoading: true,
    editTemplate: false,
    isTemplate: false,
    apiKeys: [],
    companies: [],
    companiesTotal: 0,
    clientCompanies: [],
    clientCompaniesTotal: 0,
    companyMembers: [],
    companyMembersTotal: 0,
    companyRoles: [],
    modules: [],
    appPermissions: [],
    hiringStatuses: [],
}


export default function settingReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_PLANS:
            stateCopy.plans = action.payload;
            return stateCopy;
        case GET_ACCOUNT_DETAIL:
            stateCopy.accountDetail = action.payload
            return stateCopy;
        case GET_API_KEYS:
            stateCopy.apiKeys = action.payload;
            return stateCopy;
        case CREATE_API_KEY:
            stateCopy.apiKeys = [action.payload, ...stateCopy.apiKeys];
            return stateCopy;
        case REVOKE_API_KEY:
            stateCopy.apiKeys = stateCopy.apiKeys.map(key =>
                key.id === action.payload.id ? action.payload : key
            );
            return stateCopy;
        case DELETE_API_KEY:
            stateCopy.apiKeys = stateCopy.apiKeys.filter(key => key.id !== action.payload);
            return stateCopy;
        case GET_COMPANIES:
            stateCopy.companies = Array.isArray(action.payload.data) ? action.payload.data : Array.isArray(action.payload) ? action.payload : [];
            stateCopy.companiesTotal = action.payload.total ?? stateCopy.companies.length;
            return stateCopy;
        case CREATE_COMPANY:
            stateCopy.companies = [action.payload, ...stateCopy.companies];
            return stateCopy;
        case UPDATE_COMPANY_STATUS:
            stateCopy.companies = stateCopy.companies.map(c =>
                c.id === action.payload.id ? { ...c, is_active: action.payload.is_active } : c
            );
            return stateCopy;
        case UPDATE_COMPANY:
            stateCopy.companies = stateCopy.companies.map(c =>
                c.id === action.payload.id ? { ...c, ...action.payload } : c
            );
            return stateCopy;
        case GET_CLIENT_COMPANIES:
            stateCopy.clientCompanies = Array.isArray(action.payload.data) ? action.payload.data : Array.isArray(action.payload) ? action.payload : [];
            stateCopy.clientCompaniesTotal = action.payload.total ?? stateCopy.clientCompanies.length;
            return stateCopy;
        case CREATE_CLIENT_COMPANY:
            if (stateCopy.clientCompanies.some(c => c.id === action.payload.id)) {
                return stateCopy;
            }
            stateCopy.clientCompanies = [action.payload, ...stateCopy.clientCompanies];
            return stateCopy;
        case UPDATE_CLIENT_COMPANY_STATUS:
            stateCopy.clientCompanies = stateCopy.clientCompanies.map(c =>
                c.id === action.payload.id ? { ...c, is_active: action.payload.is_active } : c
            );
            return stateCopy;
        case UPDATE_CLIENT_COMPANY:
            stateCopy.clientCompanies = stateCopy.clientCompanies.map(c =>
                c.id === action.payload.id ? { ...c, ...action.payload } : c
            );
            return stateCopy;
        case GET_COMPANY_ROLES:
            stateCopy.companyRoles = Array.isArray(action.payload) ? action.payload : [];
            return stateCopy;
        case GET_MODULES:
            stateCopy.modules = Array.isArray(action.payload) ? action.payload : [];
            return stateCopy;
        case GET_APP_PERMISSIONS:
            stateCopy.appPermissions = Array.isArray(action.payload) ? action.payload : [];
            return stateCopy;
        case CREATE_COMPANY_ROLE:
            if (action.payload?.id) {
                stateCopy.companyRoles = [action.payload, ...stateCopy.companyRoles.filter(r => r.id !== action.payload.id)];
            }
            return stateCopy;
        case UPDATE_COMPANY_ROLE:
            stateCopy.companyRoles = stateCopy.companyRoles.map(r =>
                r.id === action.payload?.id ? { ...r, ...action.payload } : r
            );
            return stateCopy;
        case DELETE_COMPANY_ROLE:
            stateCopy.companyRoles = stateCopy.companyRoles.filter(r => r.id !== action.payload);
            return stateCopy;
        case GET_COMPANY_MEMBERS:
            stateCopy.companyMembers = Array.isArray(action.payload)
                ? action.payload
                : Array.isArray(action.payload?.data)
                    ? action.payload.data
                    : [];
            stateCopy.companyMembersTotal = action.payload?.pagination?.total ?? stateCopy.companyMembers.length;
            return stateCopy;
        case ADD_COMPANY_MEMBER:
            stateCopy.companyMembers = [action.payload, ...stateCopy.companyMembers];
            return stateCopy;
        case UPDATE_MEMBER_PERMISSIONS:
            stateCopy.companyMembers = stateCopy.companyMembers.map(m =>
                m.id === action.payload.id ? { ...m, ...action.payload } : m
            );
            return stateCopy;
        case UPDATE_MEMBER_STATUS:
            stateCopy.companyMembers = stateCopy.companyMembers.map(m =>
                m.id === action.payload.id ? { ...m, is_active: action.payload.is_active } : m
            );
            return stateCopy;
        case GET_MEMBER_BY_ID:
            stateCopy.companyMembers = stateCopy.companyMembers.map(m =>
                m.id === action.payload.id ? { ...m, ...action.payload } : m
            );
            return stateCopy;
        case GET_HIRING_STATUSES:
            stateCopy.hiringStatuses = Array.isArray(action.payload) ? action.payload : [];
            return stateCopy;
        case CREATE_HIRING_STATUS:
            stateCopy.hiringStatuses = [...stateCopy.hiringStatuses, action.payload];
            return stateCopy;
        case UPDATE_HIRING_STATUS:
            stateCopy.hiringStatuses = stateCopy.hiringStatuses.map(s =>
                s.id === action.payload.id ? { ...s, ...action.payload } : s
            );
            return stateCopy;
        case DELETE_HIRING_STATUS:
            stateCopy.hiringStatuses = stateCopy.hiringStatuses.map(s =>
                s.id === action.payload ? { ...s, is_active: false } : s
            );
            return stateCopy;
        case REORDER_HIRING_STATUSES:
            stateCopy.hiringStatuses = Array.isArray(action.payload) ? action.payload : stateCopy.hiringStatuses;
            return stateCopy;
        default:
            return state;
    }
}